<div class="page">
  <div class="content" [@routeAnimations]="o && o.activatedRouteData && o.activatedRouteData['animation']">
    <router-outlet #o="outlet"></router-outlet>
  </div>
  <div class="content-footer">
    <app-footer/>
  </div>
</div>
